module.exports = __webpack_public_path__ + "static/media/HK-Lingnan.9e9ad706.png";